
/**
 * OS 타입을 정의한 ENUM
 * @readonly
 * @enum {Number} OS 타입
 */
export const OS_TYPES = {
    /** 윈도우즈 OS */
    WINDOWS: 1 
}

export default OS_TYPES
